import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress } from '@material-ui/core';
import { fade, makeStyles } from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOnlinePreviewUrlAction } from '../../../reducers/patients';
import CubeIcon from '../../../components/SvgIcons/CubeIcon';

const PREVIEW_GREEN = '#019934';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(0.25, 1.25),
    minWidth: 0,
    whiteSpace: 'nowrap',
    margin: theme.spacing(0, 0.5),
    color: PREVIEW_GREEN,
    borderColor: PREVIEW_GREEN,
    backgroundColor: fade(PREVIEW_GREEN, 0.08),
    '&:hover': {
      backgroundColor: fade(PREVIEW_GREEN, 0.16),
      borderColor: PREVIEW_GREEN
    },
    '& .MuiButton-label': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 1
    }
  },
  content: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cubeIcon: {
    fontSize: 18,
    marginRight: theme.spacing(0.75)
  },
  launchIcon: {
    fontSize: 14,
    marginLeft: theme.spacing(0.5)
  }
}));

const PatientPreviewButton = ({ patient }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const canPreview = useSelector(state =>
    state.patients.onlinePreviewAvailableIds.includes(patient.id)
  );

  const handleClick = event => {
    event.stopPropagation();
    if (isLoading || !canPreview) {
      return;
    }

    setIsLoading(true);
    dispatch(fetchOnlinePreviewUrlAction(patient.id))
      .then(url => {
        if (url) {
          window.open(url, '_blank');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (!canPreview) {
    return null;
  }

  return (
    <Button
      name="previewPatient"
      variant="outlined"
      size="small"
      className={classes.button}
      onClick={handleClick}
      disabled={isLoading}
    >
      <span className={classes.content}>
        {isLoading ? (
          <CircularProgress size={16} color="inherit" className={classes.cubeIcon} />
        ) : (
          <CubeIcon className={classes.cubeIcon} />
        )}
        Preview
        <OpenInNewIcon className={classes.launchIcon} />
      </span>
    </Button>
  );
};

PatientPreviewButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired
};

export default PatientPreviewButton;
